const joinClasses = (arr: any[]) => {
  if (arr.some((c) => typeof c === "string"))
    return arr
      .filter((c) => typeof c === "string")
      .join(" ")
      .trim();

  return undefined;
};

const validateEmail = (email: string) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export { joinClasses, validateEmail };
